<div class="updating-sheet-dialog">
  <div class="dialog-content">
    <!-- Loading State -->
    <div *ngIf="!isCompleted" class="loading-state">
      <mat-spinner diameter="60" strokeWidth="4"></mat-spinner>
      <h2 class="dialog-title">{{ message }}</h2>
      <div class="progress-tracking">
        <div class="progress-item" *ngIf="publishedTotal > 0">
          <p>{{ publishedCount }} of {{ publishedTotal }} Updated</p>
        </div>
        <div class="progress-item" *ngIf="deletedTotal > 0">
          <p>{{ deletedCount }} of {{ deletedTotal }} deleted</p>
        </div>
        <div class="progress-item" *ngIf="errorTotal > 0">
          <p>{{ errorCount }} of {{ errorTotal }} errors</p>
        </div>
        <div class="progress-item" *ngIf="apiErrorTotal > 0">
          <p>{{ apiErrorCount }} of {{ apiErrorTotal }} API errors</p>
        </div>
      </div>
    </div>

    <!-- Completion State -->
    <div *ngIf="isCompleted" class="success-state">
      <div class="sheet-update-message">The sheet has been updated.</div>
      <div class="processing-message" *ngIf="processingStatus === 'processing' && submittedRecordCount && remainingProcessingMinutes">
        Your <strong>{{ submittedRecordCount }} records</strong> have been submitted for processing.
        These changes have approximately <strong>{{ remainingProcessingMinutes }} {{ remainingProcessingMinutes === 1 ? 'minute' : 'minutes' }}</strong> remaining.
        Please do not resubmit the same changes until processing completes. Thank you for your patience.
      </div>
      <div class="processing-message" *ngIf="processingStatus === 'ready' && submittedRecordCount">
        Your <strong>{{ submittedRecordCount }} records</strong> processing requests should now be ready.
      </div>
      <div class="processing-message" *ngIf="!processingStatus">
        {{ updatedRecords }} of {{ totalRecords }} records were refreshed.
      </div>
      <button (click)="onOkClick()" class="ok-button">OK</button>
    </div>
  </div>
  <div class="loader-note"> <span class="font-semibold">Note: </span> <span class="italic">Please do not close until the process is completed.</span> </div>
</div>
